<template>
  <div class="my-look-container" :class="{
    isMobile: isMobile()
  }">
    <div class="common-content-box sys-max-width">
      <div class="content lg-mx">
        
        <!-- 有内容 -->
        <div v-if="allContentList.length > 0" class="is-content">
          <div class="block-title">
            <div class="title">近期浏览</div>
          </div>

          <div class="video-hot-box grid lg:grid-cols-4 md:grid-cols-4 grid-cols-1 gap-8">
            <div @click="goDetail(item)" class="video-item" v-for="(item, index) in hotContentList" :key="index">
              <div class="img overflow-hidden">
                <img v-if="item.cover" class="img-common" :src="item.cover.url" alt="">
                <div class="time-box">
                  <div class="time-text">{{ item.video_time }}</div>
                </div>
              </div>

              <div class="title">{{ item.title }}</div>

              <!-- <div class="desc line-clamp-3">{{ item.desc }}</div> -->
            </div>
          </div>

          <div class="block-title">
            <div class="title">更早浏览</div>
          </div>

          <div class="video-box grid lg:grid-cols-4 md:grid-cols-4 grid-cols-1 gap-8">
            <div @click="goDetail(item)" class="video-item" v-for="(item, index) in allContentList" :key="index">
              <div class="img overflow-hidden">
                <img v-if="item.cover" class="img-common" :src="item.cover.url" alt="">
                <div class="time-box">
                  <div class="time-text">{{ item.video_time }}</div>
                </div>
              </div>

              <div class="title">{{ item.title }}</div>

              <!-- <div class="desc line-clamp-3">{{ item.desc }}</div> -->
            </div>
          </div>

          <div class="page text-center">
            <el-pagination
              background
              @current-change="currentPageChange"
              :current-page.sync="page"
              :page-size="pageSize"
              layout="prev, pager, next"
              :total="total">
            </el-pagination>
          </div>
        </div>

        <!-- 无内容 -->
        <div v-else class="no-content">
          <div class="ccc">
            <div class="icon"></div>
            <div class="flex">
              <div class="text">您还没有观看过视频课程哦！去观看</div>
              <div class="link" @click="$router.push({name: 'video'})">视频课程></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { fetchHistoryVideo } from '@/api/video'
import pageMixins from '@/mixins/page'
import { isMobile } from '@/utils/index'

export default {
  mixins: [pageMixins],

  data() {
    return {
      allContentList: [],

      hotContentList: []
    }
  },
  mounted() {

  },
  methods: {
    isMobile,

    goDetail(item) {
      this.$router.push({
        name: 'videoDetail',
        query: {
          id: item.id,
          video_code: item.video_code
        }
      })
    },

    async getAllContentList() {
      try {
        const { data, total } = await fetchHistoryVideo({
          page: this.page,
          pageSize: this.pageSize,
          pid: this.moduleId
        })

        this.allContentList = data

        
        let hotContentList = []
        for (let i = 0; i < 4; i++) {
          if (data[i]) {
            hotContentList.push(data[i])
          }
        }
        this.hotContentList = hotContentList

        this.total = Number(total)
      } catch (error) {
        
      }
    }
  },
  created() {
    // 全部视频
    this.getAllContentList()
  }
}
</script>

<style lang="scss">
.my-look-container {
  background: $bg;

  &.isMobile {
    .video-item {
      .img {
        height: 195px;
      }
    }
  }

  .no-content {
    // height: 200px;
    margin-top: 142px;
    margin-bottom: 142px;
    // background-color: red;
    display: flex;
    // justify-content: ;
    align-items: center;
    justify-content: center;

    .ccc {
      .icon {
        width: 64px;
        height: 64px;
        background: url(~@/assets/no-icon.png) no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
      }

      .text, .link {
        font-size: 14px;
        font-weight: 400;
        color: #3C4858;
        line-height: 46px;
      }

      .link {
        color: $primary;
        cursor: pointer;
      }
    }
  }

  .video-hot-box {
    margin-bottom: 53px;
  }

  .video-box {
    margin-bottom: 53px;
  }

  .video-item {
    cursor: pointer;
    
    .img {
      border-radius: 10px;
      margin-bottom: 21px;
      height: 150px;
      position: relative;

      .time-box {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;

        .time-text {
          padding: 0 10px;
          text-align: right;
          font-size: 14px;
          font-weight: bold;
          color: #FFFFFF;
        }
      }
    }


    .title {
      font-size: 16px;
      font-weight: bold;
      color: #0A1121;
      line-height: 26px;
      // margin-bottom: 16px;
    }

    // .desc {
    //   font-size: 14px;

    //   font-weight: normal;
    //   color: #757C8A;
    //   line-height: 20px;
    // }
  }

  .block-title {
    margin-bottom: 26px;

    .title {
      font-size: 16px;
      font-weight: bold;
      color: #0A1121;
    }
  }
}
</style>
